module.exports = __webpack_public_path__ + "img/bg.1874ab5a.png";